import React from "react";

export default function MetricCard({ value, label, unit, trend, trendLabel, color, size = "md", invertTrendColor = false }) {
  const isPositive = trend > 0;
  // For some metrics (e.g. time-to-hire) a NEGATIVE trend is the good outcome.
  // invertTrendColor swaps green/red so the user reads the badge intuitively.
  const goodColor = "text-emerald-600";
  const badColor = "text-red-600";
  const trendColor = trend == null || trend === 0
    ? "text-vf-muted"
    : (invertTrendColor ? !isPositive : isPositive) ? goodColor : badColor;
  const sizes = { sm: "p-2", md: "p-3", lg: "p-4" };
  const valueSizes = { sm: "text-lg", md: "text-2xl", lg: "text-3xl" };

  return (
    <div className={`bg-white border border-slate-200 rounded-lg ${sizes[size]} flex-1 min-w-0`}>
      <div className={`${valueSizes[size]} font-bold`} style={{ color: color || "#1E293B" }}>
        {value}{unit && <span className="text-xs font-normal text-vf-muted ml-1">{unit}</span>}
      </div>
      <div className="text-xs text-vf-muted mt-0.5">{label}</div>
      {trend !== undefined && trend !== null && (
        <div className={`text-[11px] mt-1 ${trendColor} font-medium`}>
          {isPositive ? "▲" : trend < 0 ? "▼" : "—"} {Math.abs(trend)}%
          {trendLabel && <span className="text-vf-muted font-normal ml-1">{trendLabel}</span>}
        </div>
      )}
    </div>
  );
}
